module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonereb-00.2.5df33567.jpg";